import { SizedBox } from "@/components/core/SizedBox";
import { useParams } from "react-router-dom";
import { Title } from "./Title";
import { Details } from "./Details";
import { Content, ProjectSection } from "./Content";
import { useTranslation } from "react-i18next";
import "@/pages/Project/style.css";
import { Photos } from "./Photos";
import { myIcons, projectPhotos } from "@/utils/icons";

// 🔹 Tipler
type ProjectPhotoKey = keyof typeof myIcons.projectPhotos;

interface ProjectI {
    id: number;
    title: string;
    icon: string;
    photos: ProjectPhotoKey[];
    type: string;
    topic: string;
    date: string;
    persons: number;
    state: string;
    sections: ProjectSection[];
}

const Project = () => {
    const { id } = useParams();
    const { t } = useTranslation();

    // Tüm projeleri i18next'ten alıyoruz (returnObjects: true önemli)
    const projects = t("projects", { returnObjects: true }) as ProjectI[];
    const project = projects.find((p) => p.id === parseInt(id!));

    if (!project || project.id === 2 || project.id === 8) {
        return <div>Proje bulunamadı</div>;
    }
    const photos = projectPhotos[project.id] || [];

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: "var(--color-bg)",
                alignItems: "start",
            }}
        >
            <div
                className="project-view"
                style={{
                    maxWidth: "1000px",
                }}
            >
                <SizedBox height={10} />
                <Title title={project.title} icon={project.icon} type={project.type} />
                <Details
                    topic={project.topic}
                    date={project.date}
                    persons={project.persons}
                    state={project.state}
                />
                <Content sections={project.sections} />
                <Photos photos={photos} />

            </div>
        </div>
    );
};

export default Project;
